import React from 'react';
import { DatePicker } from 'antd';
import { useFormikContext } from 'formik';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import { FormFieldWrapper } from './FormFieldWrapper';

// Enable plugins for dayjs
dayjs.extend(customParseFormat);
dayjs.extend(utc);

export const DateField = ({ name, label, disabled, required }: any) => {
  const { setFieldValue, values } = useFormikContext<any>();

  const handleChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      // Save the date in ISO format for MongoDB (UTC)
      setFieldValue(name, date.utc().toISOString());
    } else {
      setFieldValue(name, null);
    }
  };

  return (
    <FormFieldWrapper name={name} label={label} required={required}>
      <DatePicker
        value={values[name] ? dayjs.utc(values[name]) : undefined} // Parse ISO date in UTC for display
        onChange={handleChange} // Save in ISO format (UTC)
        disabled={disabled}
        style={{ width: '100%' }}
        format="DD-MM-YYYY" // Display format
        className="rounded-xl border-gray-200 hover:border-blue-300 focus:border-blue-500 focus:shadow-lg transition-all duration-200 text-base"
      />
    </FormFieldWrapper>
  );
};
